/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import {React} from '../utils/thirdpartyComponents'
import { InputProperty } from '../interfaces/generalInterface';
import "../components/CWInput.scss";

const CWInput = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  onPaste,
  label,
  isMandatory,
  autoFocus,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  labelSuffix,
  inputmode,
}: InputProperty) => {

  return (
    <div className="form-group cw-input">
      <div className="cust-label-group">
        <label htmlFor="label">
          {label}
          {isMandatory && <span className="mandatory">*</span>}
          {labelSuffix ? <span className="label-suffix-class">{labelSuffix}</span> : ''}
        </label>
        <input
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          autoFocus={autoFocus}
          name={name}
          type={type}
          accept={accept}
          inputMode={inputmode}
          value={value}
          pattern={pattern}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onChange && onChange(event)}
          onBlur={(event) => onBlur && onBlur(event)}
          step={step}
          onFocus={(event) => onFocus && onFocus(event)}
          onKeyDown={(event) => onKeyPress && onKeyPress(event)}
          onPaste={(event) => onPaste && onPaste(event)}
        />
      </div>
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div>
  );
};

export default CWInput;
